import { render } from "./EpiContentArea.vue?vue&type=template&id=d9dbe468"
import script from "./EpiContentArea.vue?vue&type=script&lang=js"
export * from "./EpiContentArea.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__